<div class="single-date-picker">
  <div class="input-group">
    <input
      type="text"
      bsDatepicker
      [bsConfig]="bsConfig"
      [ngModel]="date"
      (ngModelChange)="onDateSelect($event)"
      class="form-control"
      #dateInput="bsDatepicker"
    />
    <button
      class="btn btn-secondary btn-ripple"
      type="button"
      (click)="openCalendar()"
    >
      <i class="fa-duotone fa-calendar-days"></i>
      <span class="visually-hidden">Calendário</span>
    </button>
  </div>
</div>
